import React, { useMemo } from 'react';
import cx from 'classnames';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { bool } from 'prop-types';

import { useEventState, useSportsbookState } from '@atlas/core';
import { Label } from '@atlas/ui';

const propTypes = { period: bool };
const sportsbookIdsWithLabel = ['favorite', 'sport'];

const EventLiveStatus = ({ className, period = true }) => {
  const {
    info: {
      score: { liveStatus, matchClock, shortLiveStatus },
    },
  } = useEventState();

  const { id } = useSportsbookState();

  const showLabel = sportsbookIdsWithLabel.includes(id);
  const eventLiveStatusClassName = cx('event-live-status', className);

  dayjs.extend(duration);
  const time = useMemo(() => {
    const numberMatchClock = parseInt(matchClock);
    if (!Number.isFinite(numberMatchClock) || numberMatchClock < 0) {
      return '';
    }

    const durationTime = dayjs.duration(numberMatchClock, 'seconds');
    const minutes =
      Math.floor(durationTime.asMinutes()) < 10
        ? `0${Math.floor(durationTime.asMinutes())}`
        : Math.floor(durationTime.asMinutes());
    const seconds =
      durationTime.seconds() < 10 ? `0${durationTime.seconds()}` : durationTime.seconds();

    return `${minutes}:${seconds}`;
  }, [matchClock]);

  const status = (period && shortLiveStatus) || liveStatus;

  return (
    <>
      <div className={eventLiveStatusClassName}>
        {showLabel && (
          <Label className="event-live-status__item event-live-indicator" message="live" />
        )}
        {period && (
          <span className="event-live-status__item event-status-period period">{status}</span>
        )}
        {time && matchClock !== null && (
          <span className="event-live-status__item event-live-time time">{time}</span>
        )}
      </div>
    </>
  );
};

EventLiveStatus.propTypes = propTypes;

export default EventLiveStatus;
